{
  "flash": {
    "listing_closed": "Listing closed successfully.",

    "application_sent": "Application sent.",
    "application_rejected": "Application rejected.",
    "application_cancelled": "Application cancelled.",
    "application_ready_to_accept": "Application ready to accept.",
    "application_accepted": "Application accepted.",

    "invitation_error": "An error occurred sending the invitation. Please try again.",
    "invitation_sent": "Invitation sent.",
    "invitation_rejected": "Invitation rejected.",
    "invitation_accepted": "Invitation accepted.",
    "invitation_cancelled": "Invitation cancelled.",
    "invitation_ready_to_accept": "Invitation ready to accept."
  },
  "state": {
    "open": "Open",
    "closed": "Closed",
    "accepted": "Accepted"
  },
  "form": {
    "priority_label": "(P{{priority}} #{{index}})",
    "sections": {
      "details": "Details",
      "tags": "Tags"
    },
    "details_section": {
      "title": "Title",
      "description": "Description",
      "invite_only": "Privacy Level",
      "start_date": "Start Date",
      "end_date": "End Date",
      "priority": "Class Offering"
    },
    "tags_section": {
      "section_description": "Select tags to help the desired teacher find the class."
    }
  },
  "new": {
    "title": "New Relief Listing"
  },
  "index": {
    "title": "Relief Listings",
    "create": "Create Relief Listing",
    "empty_list_title": "No Relief Listings",
    "empty_list_description": "Click the create button to create your first relief listing.",
    "start_date": "Start Date",
    "end_date": "End Date",
    "actions": {
      "requests": "Requests",
      "view_listing": "View Listing",
      "close": "Close Listing",
      "close_description": "This will close all pending invitations and applications. This action cannot be undone."
    }
  },
  "invitations": {
    "form": {
      "message": "Message",
      "message_pro_forma": "We’re interested in discussing an open relief teaching position.\nWe look forward to connecting with you.",
      "listing": "Listing",
      "disabled_listing": "An invitation or application already exists for this listing profile."
    },
    "send": "Send Invitation",
    "new": {
      "title": "Invite {{name}}",
      "description": "Start the conversation about filling your open relief teaching role."
    },
    "responses": {
      "new": {
        "title": "Invitation from {{educator_name}} for {{relief_listing_title}}",
        "status_description": {
          "ready_to_accept": "You've been invited to cover {{relief_listing_title}} at {{educator_name}}. Accept or decline below, or respond to the invitation email to discuss.",
          "consideration": "You've been invited to cover {{relief_listing_title}} at {{educator_name}}. Reply to the invitation email to discuss next steps.",
          "accepted": "This invitation to {{relief_listing_title}} has been accepted",
          "rejected": "This invitation to {{relief_listing_title}} has been rejected",
          "cancelled": "this invitation to {{relief_listing_title}} has been cancelled"
        },
        "warning": "This decision is permanent and cannot be undone.",
        "accept": "Accept",
        "reject": "Reject",
        "accept_info": {
          "heading": "Accept invitation",
          "description": "You agree to teach the class at the agreed upon time and dates with the educator."
        },
        "reject_info": {
          "heading": "Reject invitation",
          "description": "You won't teach the class. This action cannot be undone."
        }
      }
    }
  },
  "applications": {
    "form": {
      "message": "Message",
      "message_pro_forma": "I'm interested in discussing the relief teaching position.\nI look forward to connecting with you.",
      "listing_profile": "Listing Profile",
      "disabled_listing": "An invitation or application already exists for this listing profile."
    },
    "send": "Apply",
    "title": "Application to {{title}} ({{educator_name}})",
    "new": {
      "description": "Apply to be considered to teach."
    },
    "edit": {
      "title": "Application to {{relief_listing_title}} ({{educator_name}})",
      "status_description": {
        "ready_to_accept": "You've applied to cover {{relief_listing_title}} ({{educator_name}}). Accept or cancel below, or respond to the email to discuss.",
        "consideration": "You've applied to cover {{relief_listing_title}} ({{educator_name}}). You must await a decision from the educator or cancel your application below.",
        "accepted": "This application to {{relief_listing_title}} has been accepted",
        "cancelled": "This application to {{relief_listing_title}} has been cancelled",
        "rejected": "This application to {{relief_listing_title}} has been rejected"
      },
      "warning": "This decision is permanent and cannot be undone.",
      "accept": "Accept",
      "cancel": "Cancel",
      "accept_info": {
        "heading": "Accept Application",
        "description": "You agree to teach the class at the agreed upon time and dates."
      },
      "cancel_info": {
        "heading": "Cancel Application",
        "description": "Cancel your application to teach the class. This action cannot be undone and you cannot apply again."
      }
    }
  },
  "requests": {
    "types": {
      "invitation": "Invitation",
      "application": "Application"
    },
    "status": {
      "ready_to_accept": "Pending Acceptance",
      "consideration": "Under Consideration",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "index": {
      "title": "Requests",
      "empty_list_title": "No Requests",
      "empty_list_description": "There are no requests for this listing. Use the invite button below to start inviting educators to this listing.",
      "invite": "Invite Educators",
      "view_listing": "View Listing",
      "actions": {
        "cancel_description": "By cancelling this invitation the educator cannot apply or be invited again. This action cannot be undone.",
        "cancel": "Cancel Invitation",
        "reject_description": "By rejecting this application the educator cannot apply again. This action cannot be undone.",
        "reject": "Reject Application",
        "allow_acceptance_description": "A email will be sent to the educator so they can accept the {{type}}. Continue?",
        "allow_acceptance": "Allow Acceptance"
      }
    }
  },
  "bookings": {
    "record": "Booking",
    "types": {
      "educator": "Educator",
      "learner": "School"
    },
    "index": {
      "title": "Relief Bookings",
      "empty_list_title": "No Bookings",
      "empty_list_description": "You have no active bookings. Use the button below to start applying to relief listings.",
      "search": "Search for Relief Listings",
      "subject": "Subject",
      "start_date": "Start Date",
      "end_date": "End Date",
      "actions": {
        "view_listing": "View Listing",
        "view_students": "Students"
      }
    },
    "students.index": {
      "title": "Students",
      "view_student": "View Student"
    }
  }
}
